export default "__VITE_ASSET__v0qMC4yv__"